<template>
  <div>
    <b-form-select
      :id="id"
      :class="fieldClass"
      v-model="fieldValue"
      :required="required"
      :name="name"
      :options="options"
      @change="updateValue(fieldValue)"
    />
  </div>
</template>

<script>
export default {
  name: "OgReferenceSelect",
  data() {
    return {
      fieldValue: null,
    };
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    fieldClass: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  methods: {
    updateValue(value) {
      this.$emit("change", value);
    },
  },
  mounted() {
    this.fieldValue = this.value;
  },
};
</script>

<style scoped></style>
